export const getBaseUrl = () => {
  return "https://always-stream.onrender.com";
};
